import { useMemo } from 'react';
import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useCompanyDocumentCategory from '../useCompanyDocumentCategory';
import { getCompanyDocumentCategoryViewSections } from '../companyDocumentCategoryViewSections';

const ViewSection = ({ title, fields }) => (
  <List
    header={<div>{title}</div>}
    style={{ marginTop: 24 }}
    dataSource={fields}
    renderItem={(item) => (
      <List.Item>
        <b className={styles.itemName}>{item.text}</b>
        {item.value}
      </List.Item>
    )}
  />
);

const SingleCompanyCategoryDocument = () => {
  const { t } = useTranslation();
  const { singleData, loading } = useCompanyDocumentCategory(false);
  const [searchParams] = useSearchParams();

  const isSuccessUpdatePage = searchParams.get('success') === 'true';

  const sections = useMemo(
    () => getCompanyDocumentCategoryViewSections(t, singleData),
    [t, singleData],
  );

  const pageTitle = isSuccessUpdatePage
    ? t('COMPANY CATEGORY WAS SUCCESSFULLY UPDATED.')
    : singleData?.title || t('CATEGORIE DOCUMENTI');

  return (
    <div>
      <PageHeader title={pageTitle} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          {sections.map((section) => (
            <ViewSection
              key={section.title}
              title={section.title}
              fields={section.fields}
            />
          ))}
        </Spin>
        <Divider />
        <Row gutter={16}>
          {singleData?.can_update !== false && (
            <Col>
              <Button>
                <Link
                  to={`/documents/company_document_categories/${singleData?.id}/edit`}
                >
                  {t('MODIFICA')}
                </Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={'/documents/company_document_categories'}>
                {t('TORNA INDIETRO')}
              </Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SingleCompanyCategoryDocument;
